import { ReactNode } from "react";
import { View } from "./View";

export interface ISectionedHorizontalLinedTableProps {
  children: ReactNode;
  className?: string;
}

export const SectionedHorizontalLinedTable = (
  props: ISectionedHorizontalLinedTableProps
) => {
  return <View {...props} />;
};
